<!-- eslint-disable max-len -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-toolbar flat outlined>
      <v-btn icon :link="false" @click="back">
        <v-icon>fa-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Detalles del Servicio Doméstico</v-toolbar-title>
    </v-toolbar>
    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Datos Personales</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.nombres"
            label="Nombre(s)"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.apellido_paterno"
            label="Primer Apellido"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.apellido_materno"
            label="Segundo Apellido"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-select class="my-0 py-0"
            v-model="domestico_info.sexo"
            label="Sexo"
            :items="tipo_sexo"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="fecha_nacimiento"
            label="Fecha Nacimiento"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.nacionalidad"
            label="Nacionalidad"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.originario"
            label="Originario"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.curp"
            label="CURP"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.estado_civil"
            label="Estado Civil"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.rfc"
            label="RFC"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.n_seguridad_social"
            label="Núm. SS"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.domicilio"
            label="Domicilio"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.colonia"
            label="Colonia"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.localidad"
            label="Localidad"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.estado"
            label="Estado"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.codigo_postal"
            label="Código Postal"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.telefono"
            label="Teléfono"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.celular"
            label="Celular"
            placeholder=""
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>En caso de emergencia avisar a</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.emergencia_nombre"
            label="Nombre Completo"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.emergencia_parentesco"
            label="Parentesco"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.emergencia_telefono"
            label="Celular"
            placeholder=""
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Atributos del Personal</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.puesto"
            label="Puesto/Actividad"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.status"
            label="Estatus"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-textarea class="my-0 py-0"
            v-model="domestico_info.motivo_baja"
            label="Motivo de Baja"
            :value="domestico_info.motivo_baja"
            rows="1"
            no-resize
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 >
          <strong>Uso Autorizado de</strong>
            <v-divider/>
        </v-flex>
        <v-flex xs12 sm2 md2>
          <v-checkbox class="my-0 py-0"
            v-model="autorizaciones_info.carrito_golf"
            label="Carrito de Golf"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm10 md10 >
          <v-text-field class="my-0 py-0"
            v-model="autorizaciones_info.carrito_golf_detalles"
            label=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm2 md2>
          <v-checkbox class="my-0 py-0"
            v-model="autorizaciones_info.vehiculo_residente"
            label="Vehículo Residente"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-text-field class="my-0 py-0"
            v-model="autorizaciones_info.vehiculo_residente_detalles"
            label=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm2 md2>
          <v-checkbox class="my-0 py-0"
            v-model="autorizaciones_info.vehiculo_particular"
            label="Vehículo Particular"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-text-field class="my-0 py-0"
            v-model="autorizaciones_info.vehiculo_particular_detalles"
            label=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm2 md2>
          <v-checkbox class="my-0 py-0"
            v-model="autorizaciones_info.bicicleta"
            label="Bicicleta"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-text-field class="my-0 py-0"
            v-model="autorizaciones_info.bicicleta_detalles"
            label=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm2 md2>
          <v-checkbox class="my-0 py-0"
            v-model="autorizaciones_info.motocicleta"
            label="Motocicleta"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-text-field class="my-0 py-0"
            v-model="autorizaciones_info.motocicleta_detalles"
            label=""
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Datos del Empleador</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-text-field class="my-0 py-0"
            v-model="domestico_info.vivienda"
            label="Vivienda"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm8 md8>
          <v-text-field class="my-0 py-0"
            v-model="residente_fullname"
            label="Residentes"
            placeholder=""
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Condiciones de Acceso</strong>
          <v-divider/>
        </v-flex>
        <!--
        <v-flex xs12 sm4 md4>
          <v-checkbox class="my-0 py-0"
            v-model="acceso_info.acceso_multiple"
            label="Acceso Multiple"
            readonly
          />
        </v-flex>
        -->
        <v-flex xs12 sm6 md6>
          <v-text-field class="my-0 py-0"
            :value="formatter_date(acceso_info.vigente_desde, 'YYYY-MM-DD')"
            label="Fecha de Inicio"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field class="my-0 py-0"
            :value="formatter_date(acceso_info.vigente_hasta, 'YYYY-MM-DD')"
            label="Vigente Hasta"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm12 md12>
          <v-select class="my-0 py-0"
            v-model="selected_acceso_dias"
            label="Días Permitidos"
            :items="acceso_dias"
            multiple
            chips
            readonly
          />
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-select class="my-0 py-0"
            v-model="acceso_info.acceso_todo_dia"
            label="Horario"
            :items="tipo_acceso"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-text-field class="my-0 py-0"
            v-model="acceso_info.hora_desde"
            label="Hora Entrada"
            placeholder=""
            readonly
          />
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-text-field class="my-0 py-0"
            v-model="acceso_info.hora_hasta"
            label="Hora Salida"
            placeholder=""
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Dispositivos Biométricos</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm12 md12>
          <v-select class="my-0 py-0"
            v-model="selected_faciales"
            :items="faciales_proveedores"
            label="Portico Proveedores"
            multiple
            chips
            readonly
          />
        </v-flex>
        <!--
         <v-flex xs12 sm6 md6>
          <v-select class="my-0 py-0"
            v-model="selected_faciales"
            :items="faciales_principal"
            label="Portico Principal"
            multiple
            chips
            readonly
          />
        </v-flex>
        -->
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Fotos</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <label>Foto Personal Doméstico</label>
          <img :src="decode_base64('foto')" style="width: 100%" alt="Foto Personal Doméstico"/>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <label>Foto INE (frente)</label>
          <img :src="decode_base64('ine_frente')" style="width: 100%" alt="Foto INE (frente)"/>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <label>Foto INE (reverso)</label>
          <img :src="decode_base64('ine_reverso')" style="width: 100%" alt="Foto INE (reverso)"/>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import moment from '../../node_modules/moment';

export default {
  components: {
  },
  data: () => ({
    domestico_info: {},
    selected_acceso_dias: [],
    residente_fullname: '',
    fecha_nacimiento: '',
    acceso_info: [],
    autorizaciones_info: [],
    selected_faciales: [],
    tipo_status: [
      { text: 'Inactivo', value: 'inactivo' },
      { text: 'Activo', value: 'activo' },
    ],
    tipo_sexo: [
      { text: 'Masculino', value: 'M' },
      { text: 'Femenino', value: 'F' },
    ],
    acceso_dias: [
      { text: 'Lunes', value: 'lunes' },
      { text: 'Martes', value: 'martes' },
      { text: 'Miércoles', value: 'miercoles' },
      { text: 'Jueves', value: 'jueves' },
      { text: 'Viernes', value: 'viernes' },
      { text: 'Sábado', value: 'sabado' },
      { text: 'Domingo', value: 'domingo' },
    ],
    tipo_acceso: [
      { text: 'Todo el día', value: true },
      { text: 'Especifico', value: false },
    ],
    faciales_proveedores: [
      { text: 'Proveedores Peatonal', value: 'proveedores_peatonal' },
      { text: 'Proveedores Vehicular', value: 'proveedores_vehicular' },
    ],
    faciales_principal: [
      { text: 'Visitantes Principal', value: 'principal_visitantes' },
      { text: 'Residentes Principal', value: 'principal_residentes' },
    ],
  }),
  computed: {
    is_loading() {
      return this.$store.getters['detallesDomestico/is_loading'];
    },
    domestico_processing() {
      return this.$store.getters['detallesDomestico/domestico_processing'];
    },
  },
  watch: {
    colaborador_processing(val) {
      this.processing = val;
    },
  },
  methods: {
    back() {
      this.$router.back();
    },
    decode_base64(type) {
      let encoded = '';
      let extension = '';
      if (type === 'foto') {
        encoded = this.domestico_info.foto_b64;
      } else if (type === 'ine_frente') {
        encoded = this.domestico_info.ine_frente_b64;
      } else if (type === 'ine_reverso') {
        encoded = this.domestico_info.ine_reverso_b64;
      }
      if (typeof encoded === 'string') {
        const check = encoded.substring(0, 3);
        if (check === '/9j') {
          extension = 'jpg';
        } else if (check === 'iVB') {
          extension = 'png';
        } else if (check === 'SUk') {
          extension = 'tiff';
        } else extension = 'bmp'; // Qk0
      } else {
        extension = 'png';
        encoded = 'R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      }

      return `data:image/${extension};base64,${encoded}`;
    },
    formatter_date(fecha, formato = 'DD-MM-YYYY') {
      const tmpfecha = this.clear_null(fecha);
      let auxfecha = '';
      if (tmpfecha !== '') {
        auxfecha = moment(tmpfecha).format(formato);
      }

      return auxfecha;
    },
    clear_null(value) {
      let tmpNull = null;
      if (typeof value === 'string') {
        if (value === 'None') {
          tmpNull = '';
        } else {
          tmpNull = value.trim();
        }
      } else if (value === null || typeof value === 'undefined') {
        tmpNull = '';
      } else {
        tmpNull = value;
      }
      return tmpNull;
    },
  },
  created() {
  },
  mounted() {
    this.$store.dispatch('detallesDomestico/fetchDomesticoInfo', this.$route.params.id)
      .then((data) => {
        this.residente_fullname = `${this.clear_null(data.nombre_residente)} ${this.clear_null(data.apellido_paterno_residente)} ${this.clear_null(data.apellido_materno_residente)}`.trim();
        this.fecha_nacimiento = this.clear_null(data.fecha_nacimiento);
        this.domestico_info = data;
        this.autorizaciones_info = data.autorizaciones;
        this.selected_faciales = data.faciales;
        if (data.acceso !== null) {
          this.acceso_info = data.acceso;
          if (data.acceso.lunes) {
            this.selected_acceso_dias.push('lunes');
          }
          if (data.acceso.martes) {
            this.selected_acceso_dias.push('martes');
          }
          if (data.acceso.miercoles) {
            this.selected_acceso_dias.push('miercoles');
          }
          if (data.acceso.jueves) {
            this.selected_acceso_dias.push('jueves');
          }
          if (data.acceso.viernes) {
            this.selected_acceso_dias.push('viernes');
          }
          if (data.acceso.sabado) {
            this.selected_acceso_dias.push('sabado');
          }
          if (data.acceso.domingo) {
            this.selected_acceso_dias.push('domingo');
          }
        }
      });
    this.editdomestico = true;
    this.dialog = true;
  },
};
</script>
<style type="text/css">

</style>
